export const ROUTES = {
  HOME: 'home',
  LOGIN: 'login',
  LOGOUT: 'logout',
  FORGOTPASSWORD: 'forgot-password',
  RESETPASSWORD: 'reset-password',
  REGISTER: 'register',
  // Payment routes
  PAYMENT_RETURN: 'payment-return',
  // Legacy dashboard routes - keeping for backward compatibility
  CUSTOMER_DASHBOARD: 'customer-dashboard',
  BUSINESS_DASHBOARD: 'business-dashboard',
  DELIVERY_DRIVER_DASHBOARD: 'delivery-driver-dashboard',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  PRIVACY_POLICY: 'privacy-policy',
  // New consolidated dashboard routes
  DASHBOARD: 'dashboard',
  DASHBOARD_INDEX: 'dashboard-index',
  DASHBOARD_ORDERS: 'dashboard-orders',
  DASHBOARD_ORDER: 'dashboard-order',
  NOT_FOUND: 'not-found',
  NOTIFICATION: 'notification',
  NOTIFICATIONS: 'notifications',
  FEEDBACKS: 'feedbacks',
  FEEDBACK: 'feedback',
  AUTH: 'auth',
  APP: 'app',
  ORDER: 'order',
  ORDERS: 'orders',
  BUSINESSES: 'businesses',
  BUSINESS_EDIT: 'business-edit',
  REGISTER_DRIVER: 'register-driver',
  PUBLIC_BUSINESSES: 'public-businesses',
  BUSINESS: 'business',
  PUBLIC_BUSINESS: 'public-business',
  // Product routes
  PRODUCTS: 'products',
  PRODUCT: 'product',
  PRODUCT_CREATE: 'product-create',
  PRODUCT_EDIT: 'product-edit',
  // Legacy order routes - keeping for backward compatibility
  CUSTOMER_ORDER: 'customer-order',
  CUSTOMER_ORDERS: 'customer-orders',
  BUSINESS_ORDER: 'business-order',
  BUSINESS_ORDERS: 'business-orders',
  BUSINESS_REVIEW: 'business-review',
  DELIVERY_DRIVER_ORDER: 'delivery-driver-order',
  DELIVERY_DRIVER_ORDERS: 'delivery-driver-orders',
  PROFILE: 'profile',
  EMAIL_VERIFICATION: 'email-verification',
  NOT_AUTHORIZED: 'not-authorized',
  PUBLIC_BUSINESS_REVIEW: 'public-business-review',
  ADMIN_PAYMENTS: 'admin-payments',
  ADMIN_PAYMENT: 'admin-payment',
  ADMIN_USERS: 'admin-users',
  ADMIN_USER: 'admin-user',
  ADMIN_SEND_NOTIFICATIONS: 'admin-send-notifications',
  ADMIN_BUSINESS_PAYMENT_BREAKDOWN: 'admin-business-payment-breakdown',
  ADMIN_CONSTANTS: 'admin-constants',
}
